export default __webpack_public_path__ + "static/media/group2.3c11c199.webp";